import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
} from "@/components/ui/dialog";
import { Sparkles, Star, XIcon } from "lucide-react";
import type { FC } from "react";
import Text from "../../Text";
import { remainingKrunshCreditsState } from "@/store/remainingKrunshCreditsState";
import { listProductsState } from "@/store/listProductsState";
import { createCheckoutSession } from "@/store/checkoutSessionState";
import { setPaymentAction } from "@/store/paymentActionState";

type Props = {
  open: boolean;
  onClose: () => void;
};

const KrunshCoinDialog: FC<Props> = ({ open, onClose }) => {
  const { data: remainingKrunshCredits } = remainingKrunshCreditsState();
  const { data: listProducts } = listProductsState();

  return (
    <Dialog open={open}>
      <DialogContent showCloseButton={false} className="sm:max-w-[860px]">
        <DialogHeader>
          <div className="flex justify-between">
            <div className="flex items-center gap-[18px]">
              <Sparkles height={18} width={18} color="#1D4ED8" />
              <div className="flex flex-col gap-[4px]">
                <Text fontWeight={400} fontSize={24} color="#1F2937">
                  Recharger en Crédit IA
                </Text>
                <Text fontWeight={400} fontSize={16} color="#1F2937">
                  Rechargez afin de continuer vos recherches
                </Text>
              </div>
            </div>
            <XIcon onClick={onClose} className="cursor-pointer" />
          </div>
        </DialogHeader>

        <DialogDescription>
          <div className="flex items-center justify-between w-full bg-[#FAFAFB] p-[16px] rounded-[12px]">
            <Text fontWeight={400} fontSize={16} color="#1F2937">
              Solde actuel
            </Text>
            <div className="flex items-center gap-[12px]">
              <Sparkles height={18} width={18} color="#1D4ED8" />
              <div className="flex items-center gap-[4px]">
                <Text fontWeight={600} fontSize={24} color="#1F2937">
                  {remainingKrunshCredits !== null
                    ? remainingKrunshCredits
                    : "0"}
                </Text>
                <Text fontWeight={400} fontSize={16} color="#1F2937">
                  {remainingKrunshCredits !== null && remainingKrunshCredits > 1
                    ? "Crédits IA"
                    : "Crédit IA"}
                </Text>
              </div>
            </div>
          </div>

          <div className="mt-[26px] flex gap-[16px] w-full">
            {listProducts
              ?.filter((product) => product.isCreditPack)
              .sort((a, b) => {
                const aCount = a.creditPackInfo?.count || 0;
                const bCount = b.creditPackInfo?.count || 0;
                return aCount - bCount;
              })
              .map((product) => (
                <div
                  key={product.name}
                  style={{
                    border: `2px solid ${product.creditPackInfo?.popular ? "#2563EB" : "#E5E7EB"}`,
                  }}
                  className="relative flex flex-col p-[24px] rounded-[12px]"
                >
                  {product.creditPackInfo?.popular && (
                    <div className="absolute top-[-14px] left-[50%] transform -translate-x-[50%] bg-[#002D9C] flex items-center gap-[8px] py-[4px] px-[16px] rounded-[50px]">
                      <Star height={16} width={16} color="white" />
                      <Text fontWeight={500} fontSize={14} color="white">
                        POPULAIRE
                      </Text>
                    </div>
                  )}
                  <div className="flex items-center gap-[8px]">
                    <Sparkles height={24} width={24} color="#1D4ED8" />
                    <div className="flex flex-col gap-[4px]">
                      <Text fontWeight={700} fontSize={32} color="#1F2937">
                        {product.creditPackInfo?.count}
                      </Text>
                      <Text fontWeight={400} fontSize={16} color="#4B5563">
                        Crédits IA
                      </Text>
                    </div>
                  </div>
                  <div className="flex flex-col gap-[8px] mt-[24px]">
                    <div className="flex flex-col gap-[4px]">
                      <Text fontWeight={600} fontSize={24} color="#1F2937">
                        {product.prices[0]?.price
                          ? `${(product.prices[0].price / 100).toFixed(2)} €`
                          : "N.C"}
                      </Text>
                      <Text fontWeight={400} fontSize={16} color="#4B5563">
                        {product.prices[0]?.price &&
                        product.creditPackInfo?.count
                          ? `${(product.prices[0].price / 100 / product.creditPackInfo.count).toFixed(4)} €`
                          : "N.C"}{" "}
                        / crédit
                      </Text>
                    </div>
                    <Button
                      onClick={() => {
                        console.log("product before if", product);
                        if (product.defaultPrice) {
                          console.log("product after if", product);
                          createCheckoutSession({
                            priceId: product.defaultPrice,
                          });
                          setPaymentAction("creditPack");
                        }
                      }}
                    >
                      Acheter
                    </Button>
                  </div>
                </div>
              ))}
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
};

export default KrunshCoinDialog;
